import React, { useEffect, useState } from "react";
import { base_url } from "../Api/Api";
import { Loader } from "../Common/Loader";
import Itemnewsskltn from "./ItemNewsSkleton";
import Pagination from "@material-ui/lab/Pagination";

import Itemnews from "../MainPage/ItemNews";
import Cookies from "universal-cookie";

const News = (props) => {
  const [state, setState] = useState({
    data: [], // data news
    statusCards: false, // loader status
    minPaginate: 0,
    maxPaginate: 9,
    countPaginate: 0,
  });

  useEffect(() => {
    const cookies = new Cookies();

    if (cookies.get("api_key") == null) {
      props.history.push(`/Entrance`);
    }

    base_url
      .get(`latest_news?page=1`)
      .then((response) => {
        let tempData = response.data.latestNews.data;
        setState({
          ...state,
          data: tempData,
          statusCards: response.data.latestNews.length == 0,
          countPaginate: response.data.latestNews.last_page,
        });
      })
      .catch((error) => {
        if (error.response != undefined) {
          if (error.response.status == 401) {
            props.history.push(`/Entrance`);
            localStorage.clear();
            window.location.reload();
          }
        }
      });
  }, []);

  const handleChange = (event, value) => {
    base_url
      .get(`latest_news?page=${value}`)
      .then((response) => {
        let tempData = response.data.latestNews.data;
        setState({
          ...state,
          data: tempData,
          statusCards: response.data.latestNews.length == 0,
          countPaginate: response.data.latestNews.last_page,
        });
      })
      .catch((error) => {
        if (error.response != undefined) {
          if (error.response.status == 401) {
            props.history.push(`/Entrance`);
            localStorage.clear();
            window.location.reload();
          }
        }
      });
  };

  return (
    <div className="news">
      <Loader active={state.loader} />
      <div className="contain">
        <div className={`inner-news ${state.loader ? "" : "active"}`}>
          {state.data.length == 0 ? (
            state.statusCards ? (
              <span className="no-content">اطلاعاتی وجود ندارد</span>
            ) : (
              <Itemnewsskltn />
            )
          ) : (
            state.data
              .slice(state.minPaginate, state.maxPaginate)
              .map((info, index) => (
                <Itemnews
                  key={index}
                  id={info.id}
                  image={info.image}
                  title={info.title}
                  string_date={info.string_date}
                  comment_count={info.comment_count}
                  index={state.minPaginate + index}
                  tags={info.tags}
                />
              ))
          )}
        </div>
        {state.countPaginate <= 1 ? null : (
          <Pagination count={state.countPaginate} onChange={handleChange} />
        )}
      </div>
    </div>
  );
};

export default News;
